export default __webpack_public_path__ + "static/media/vacation_light.31c4997c.png";